<template>
  <b-modal ref="modal" title="Conta a Receber" header-class="border-bottom-0">
    <!-- container  -->
    <div class="container">
      <!-- first col -->
      <div class="row">
        <div class="col-8 p-0">
          <div class="row mb-2">
            <div class="col-md-12">
              <small class="text-muted">Cliente</small>
              <br />
              <span>{{ bill.person.name }}</span>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-12">
              <small class="text-muted">Documento</small>
              <br />
              <span>{{ bill.document }}</span>
            </div>
          </div>
        </div>

        <!-- second col -->
        <div class="col-4 p-0 text-right">
          <div class="row mb-2">
            <div class="col-12">
              <small class="text-muted">Valor:</small>
              <br />
              <b class="text-primary">{{ bill.value | decimal }}</b>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <small class="text-muted">Vencimento:</small>
              <br />
              <bill-receiveble-due-date-badge
                :dueDate="bill.due_date"
                :status="bill.status"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <small class="text-muted">Status:</small>
              <br />
              <bill-receiveble-status-badge :status="bill.status" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3" v-if="bill.history">
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">Historico:</label>
          <textarea
            :value="bill.history"
            maxlength="500"
            class="form-control"
            id="exampleFormControlTextarea1"
            rows="5"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div
          class="d-flex p-3"
          style="border-left: 1px solid rgba(0, 0, 0, 0.1)"
        >
          <div style="margin-left: -1.4rem">
            <i
              class="fas fa-xs fa-circle text-success"
              style="outline: 5px solid white"
            ></i>
          </div>
          <div class="d-inline ml-2">
            <span class="ml-2">Emissão</span>
            <br />
            <small class="text-muted ml-2">{{
              bill.created_at | dateTimeBr
            }}</small>
          </div>
        </div>
      </div>
    </div>
    <template v-for="payment in bill.bill_payment">
      <div class="row" :key="payment.id">
        <div class="col-12">
          <div
            class="d-flex p-3"
            style="border-left: 1px solid rgba(0, 0, 0, 0.1)"
          >
            <div style="margin-left: -1.4rem">
              <i
                class="fas fa-xs fa-circle text-success"
                style="outline: 5px solid white"
              ></i>
            </div>
            <div class="d-flex flex-grow-1 justify-content-between">
              <div class="d-inline ml-2">
                <span class="ml-2">Pagamento</span>
                 <small class="ml-2"><PaymentMethodBadge :payment-method="payment.payment_method"/></small>
                <span class="ml-2 text-danger" v-if="payment.status == 'c'"
                  >(Cancelado)</span
                >
                <br />
                <small class="text-muted ml-2">{{
                  payment.payed_at | dateTimeBr
                }}</small>
              </div>
              <div class="ml-2 text-right">
                <small class="text-muted">Valor: </small>
                <small>{{ payment.received_value | decimal }}</small>
                <br />
                <template v-if="payment.discount > 0">
                  <small class="text-danger"
                    >Desconto: {{ payment.discount | decimal }}</small
                  >
                  <br />
                </template>
                <template v-if="payment.addition > 0">
                  <small class="text-muted">Acréscimo: </small>
                  <small>{{ payment.addition | decimal }}</small>
                  <br />
                </template>
                <template v-if="payment.interest > 0">
                  <small class="text-muted">Juros: </small>
                  <small>{{ payment.interest | decimal }}</small>
                  <br />
                </template>
                <small class="text-muted">Valor Pago: </small>
                <b>{{ payment.payed_value | decimal }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- footer  -->
    <div slot="modal-footer">
      <button
        role="button"
        class="btn btn-outline-secondary"
        @click="$refs.modal.hide()"
      >
        <i class="fas fa-times"></i> Voltar
      </button>
    </div>
  </b-modal>
</template>

<script>

import BillReceivebleStatusBadge from "@/components/billReceiveble/sections/BillReceivebleStatusBadge";
import BillReceivebleDueDateBadge from "@/components/billReceiveble/sections/BillReceivebleDueDateBadge";
import PaymentMethodBadge from "@/components/account/sections/PaymentMethodBadge.vue";

export default {
  components: { BillReceivebleStatusBadge, BillReceivebleDueDateBadge, PaymentMethodBadge },

  data: function () {
    return {
      bill: {
        person : {},
        bill_payment : {}
      },
    };
  },

  methods: {
    async open(bill) {
      
      this.$store.commit("showLoading");
      
      await this.$store
        .dispatch("billreceiveble/getBillReceiveble", bill.id)
        .then((response) => {
          this.bill = response.data.bill;
          this.$refs.modal.show();
        })
        .catch((error) => {
          this.error = error;
        });

      this.$store.commit("hideLoading");
    },
  },
};
</script>
